import { APIClient } from '../lib/apiHelper'

const {get, post, put, remove} = new APIClient()

export default {
	list: () =>  get(`/code/list`),
	generate: (code) => put(`/code/generate`, code),
	download: (userId) => post(`/code/download`, { userId }),
	forceGetPersonnal: () => get('/interface/forceGetPersonnel'),
	forceGetUserGroup: () => get('/interface/forceGetUserGroup'),
	add: (attArticle) =>  post(`/sysapplyuser/add`,attArticle),
	update: (attArticle) =>  post(`/sysapplyuser/update`,attArticle),
	delete: (config_idx) =>  get(`/sysapplyuser/delete?idx=${config_idx}`),
	sapvendorexcel: (article) => post('/sapvender/sapvenderexcel',(article)),
	saplist: (attArticle) =>  get(`/sapvender/list`,attArticle),
	checkIndex: (index) => get(`/sapvender/check/${index}`),
	sapInfo: (VendorID) => get(`/sapvender/sapInfo?VendorID=${VendorID}`)
}